import { render, staticRenderFns } from "./ProjectTemplate.vue?vue&type=template&id=250af5eb&scoped=true"
import script from "./ProjectTemplate.vue?vue&type=script&lang=js"
export * from "./ProjectTemplate.vue?vue&type=script&lang=js"
import style0 from "./ProjectTemplate.vue?vue&type=style&index=0&id=250af5eb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "250af5eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContent } from 'vuetify/lib'
installComponents(component, {
  VContent,
})
